





































































































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import Panel from "primevue/panel";
import TreeTable from "primevue/treetable";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import SplitButton from 'primevue/splitbutton';
import Button from "primevue/button";
import ProgressSpinner from 'primevue/progressspinner';
import OrderList from 'primevue/orderlist';
import Message from 'primevue/message';
import ProgressBar from 'primevue/progressbar';
import AutoComplete from 'primevue/autocomplete';
import Dialog from 'primevue/dialog'
import {PDFDocument, StandardFonts, rgb} from "pdf-lib";
import axios from 'axios';
import download from "downloadjs";
// use p-queue
// import PQueue from "p-queue";
import {Web} from "@pnp/sp/webs";
import {v4 as uuidv4} from "uuid";

/**
 * Class-component
 */
@Component({
    components: {
        Panel: Vue.extend(Panel),
        TreeTable: Vue.extend(TreeTable),
        DataTable: Vue.extend(DataTable),
        Column: Vue.extend(Column),
        SplitButton: Vue.extend(SplitButton),
        Button: Vue.extend(Button),
        ProgressSpinner: Vue.extend(ProgressSpinner),
        OrderList: Vue.extend(OrderList),
        Message: Vue.extend(Message),
        ProgressBar: Vue.extend(ProgressBar),
        AutoComplete: Vue.extend(AutoComplete),
        Dialog: Vue.extend(Dialog),
    }
})
export default class StorageTool extends Vue {

    splitButtonItems: any = null;
    profile: any = null;
    teams: any = null;
    filteredTeams: any = [];
    selectedTeam: any = null;
    channels: any = null;
    filteredChannels: any = [];
    selectedChannel: any = null;
    startGetFile: any = false;
    serverRelativeUrl: any = null;
    updatedWebObj: any = null;
    name: any = null;
    folders: any = null;
    files: any = null;
    testPdf: any = null;
    teamId: any = null;
    expandedKeys: any = {};
    input: any = [];
    prevParentObj: any = null;
    pdfUrl: any = null;
    dataLoaded: any = false;
    loading: any = false;
    loadSelect: any = false;
    folderCount: any = 0;
    selectProgress: any = 0;
    selectedKey: any = {};
    selectedFiles: any = [];
    selectedFile: any = null;
    filesKey: any = [];
    blockButton: any = false;
    filesCount: any = 0;
    displayModal: any = false;
    loadPdf: any = false;
    pdfSrc: any = null;
    mergeProgress: any = 0;
    combinedPdf: any = null;
    convertRecords: any = [];
    convertTime: any = 0;
    totalTime: any = null;
    success: any = false;
    successMsg: any = null;
    error: any = false;
    errorMsg: any = null;

    async mounted() {
        this.splitButtonItems = [
            { label: 'Refresh', icon: 'pi pi-refresh', command: () => { this.$router.go(0); } },
            { label: 'Sign Out', icon: 'pi pi-sign-out', command: () => { this.$store.state.msalInstance.logout(); } }
        ];

        // profile
        this.profile = await this.$pnp.graph?.me();

        // joined teams
        const teams = await this.$pnp.graph?.me.joinedTeams();
        this.teams = teams.filter((team: any) => {
            return team.displayName.toLowerCase().startsWith('agreement');
        });
    }

    logout() {
        this.$store.state.msalInstance.logout();
    }

    expandNode(node: any) {
        if (node.children && node.children.length) {
            this.expandedKeys[node.key] = true;

            for (const child of node.children) {
                this.expandNode(child);
            }
        }
    }

    async onExpandOrSelect(node: any, mode: any) {
        this.filesKey.push(`${node.key}`);
        const subfolderNodes: any = [];

        // the node has no children and is a folder
        if (!node.children && !node.key.includes('File')) {
            this.loading = true;
            const lazyNode = {...node}; // create a new object
            lazyNode.children = [];
            const channel = this.updatedWebObj.getFolderById(node.key);
            const subfolders = await channel.folders();
            subfolders.sort((a: any, b: any) => (a.Name.toLowerCase() > b.Name.toLowerCase()) ? 1 : ((b.Name.toLowerCase() > a.Name.toLowerCase()) ? -1 : 0));

            const files = await channel.files();
            files.sort((a: any, b: any) => (a.Name.toLowerCase() > b.Name.toLowerCase()) ? 1 : ((b.Name.toLowerCase() > a.Name.toLowerCase()) ? -1 : 0));

            for (const subfolder of subfolders) {
                if (subfolder.Name.toLowerCase() === 'backup' || subfolder.Name.toLowerCase() === 'output') continue; // ignore 'Backup' & 'Output' folders
                this.filesKey.push(`${subfolder.UniqueId}`);
                const inputFolderObj: any = {
                    key: subfolder.UniqueId,
                    data: {
                        type: 'Folder',
                        name: subfolder.Name,
                        created: new Date(subfolder.TimeCreated).toLocaleString(),
                        updated: new Date(subfolder.TimeLastModified).toLocaleString()
                    },
                    leaf: false
                };
                subfolderNodes.push(inputFolderObj)
                lazyNode.children.push(inputFolderObj);
            }

            for (const file of files) {
                this.filesKey.push(`${'File'},${file.UniqueId}`); // collect all file keys for 'select all files'
                lazyNode.children.push({
                    key: `${'File'},${file.UniqueId}`,
                    data: {
                        type: 'File',
                        name: file.Name,
                        created: new Date(file.TimeCreated).toLocaleString(),
                        updated: new Date(file.TimeLastModified).toLocaleString()
                    }
                });
            }

            const lazyLoad = (input: any) => {
                if (input.length) {
                    for (const el of input) {
                        if (el.key === node.key) {
                            el.children = lazyNode.children;
                        }
                        if (el.children) {
                            lazyLoad(el.children)
                        }
                    }
                } else {
                    return
                }
            }

            lazyLoad(this.input)

            for (const subfolder of subfolderNodes) {
                if (!subfolder.key.includes('File')) {
                    if (mode === 'select') {
                        await this.onExpandOrSelect(subfolder, 'select')
                        this.selectedKey[subfolder.key] = {checked: true};
                    } else if (mode === 'selectAll') {
                        await this.onExpandOrSelect(subfolder, 'selectAll')
                        this.selectedKey[subfolder.key] = {checked: true};
                    } else {
                        await this.onExpandOrSelect(subfolder, 'expand')
                    }
                }
            }

            if (mode !== 'selectAll') {
                this.expandNode(node);
                this.expandedKeys = {...this.expandedKeys};
            }

            if (mode === 'select' || mode === 'selectAll') {
                this.filesKey.forEach((key: any) => {
                    this.selectedKey[key] = {checked: true};
                })
            }

            this.loading = false;
        }
    }

    async onExpand(node: any) {
        await this.onExpandOrSelect(node, 'expand')
    }

    async onSelect(node: any) {
        await this.onExpandOrSelect(node, 'select')
    }

    onUnselect(node: any) {
        delete this.selectedKey[node.key]
    }

    searchTeam(event: any) {
        this.channels = null
        this.selectedChannel = null
        setTimeout(() => {
            if (!event.query.trim().length) {
                this.filteredTeams = [...this.teams];
            } else {
                this.filteredTeams = this.teams.filter((team: any) => {
                    return team.displayName.toLowerCase().includes(event.query.toLowerCase());
                });
            }
        }, 200);
    }

    @Watch('selectedTeam')
    async onSelectedTeamChanged() {
        this.channels = await this.$pnp.graph?.teams.getById(this.selectedTeam.id).channels();
    }

    searchChannel(event: any) {
        setTimeout(() => {
            if (!event.query.trim().length) {
                this.filteredChannels = [...this.channels];
            } else {
                this.filteredChannels = this.channels.filter((channel: any) => {
                    return channel.displayName.toLowerCase().includes(event.query.toLowerCase());
                });
            }
        }, 200);
    }

    async getFileStructure(mode: any) {
        this.startGetFile = true;
        this.dataLoaded = false;
        this.success = false;
        this.error = false;
        this.input = [];
        this.filesKey = [];
        this.selectedKey = {};
        this.selectedFiles = [];
        this.selectedFile = null;
        this.expandedKeys = {}

        // get current channel folder
        const filesFolderUrl = await axios.get(`https://graph.microsoft.com/v1.0/teams/${this.selectedTeam.id}/channels/${this.selectedChannel.id}/filesFolder`, {
            headers: {
                'Authorization': `Bearer ${this.$store.state.graphToken}`
            }
        })

        // update ServerRelativeUrl
        this.serverRelativeUrl = `/sites/${(filesFolderUrl.data.webUrl.split(/\/sites\/.*?/))[1]}`

        // update web object
        const baseUrl = filesFolderUrl.data.webUrl.split(/\/Shared%20Documents\/.*?/)[0]
        this.updatedWebObj = Web(baseUrl)


        // get current channel folder
        const channel = await this.updatedWebObj.getFolderByServerRelativeUrl(this.serverRelativeUrl);

        // get current channel object (with properties)
        // const channelObj = await channel();

        // first layer of files (lazy load)
        const loadFirstLayerFolders = async () => {
            const subfolders = await channel.folders();
            subfolders.sort((a: any, b: any) => (a.Name.toLowerCase() > b.Name.toLowerCase()) ? 1 : ((b.Name.toLowerCase() > a.Name.toLowerCase()) ? -1 : 0));
            for (const subfolder of subfolders) {
                if (subfolder.Name.toLowerCase() === 'backup' || subfolder.Name.toLowerCase() === 'output') continue; // ignore 'Backup' & 'Output' folders
                const inputFolderObj: any = {
                    key: subfolder.UniqueId,
                    data: {
                        type: 'Folder',
                        name: subfolder.Name,
                        created: new Date(subfolder.TimeCreated).toLocaleString(),
                        updated: new Date(subfolder.TimeLastModified).toLocaleString()
                    },
                    leaf: false
                };
                this.input.push(inputFolderObj);
            }
        }

        // const mainQueue = new PQueue({concurrency: 1});

        // get input type (i.e. folder / file)
        // const getInputType = async (input: any) => {
        //     const type = await input["odata.type"].split(".")[1];
        //     return type;
        // };

        // reassign value of this.prevParentObj by checking if it's null or not
        // const findParentFolder = (folder: any) => {
        //     if (this.prevParentObj) {
        //         /*
        //          if this.prevParentObj is not null (2nd or further loop),
        //          find the parent folder from this.prevParentObj.children and set it to this.prevParentObj
        //         */
        //         const findNestedFolder = this.prevParentObj.children.find(
        //             (el: any) => el.key == folder.UniqueId
        //         );
        //
        //         if (findNestedFolder !== undefined) {
        //             this.prevParentObj = findNestedFolder;
        //         }
        //     } else {
        //         /*
        //           if this.prevParentObj is null (first loop), which means it's in 2nd nested folder,
        //           find the parent folder from this.input and set it to this.prevParentObj
        //         */
        //         this.prevParentObj = this.input.find(
        //             (el: any) => el.key == folder.UniqueId
        //         );
        //     }
        // };

        // insert files to this.input
        // const loopFilesToUpdateInputData = async (files: any) => {
        //     files.sort((a: any, b: any) => (a.Name.toLowerCase() > b.Name.toLowerCase()) ? 1 : ((b.Name.toLowerCase() > a.Name.toLowerCase()) ? -1 : 0));
        //     for (const file of files) {
        //         const type = await getInputType(file);
        //
        //         this.filesKey.push(`${type},${file.UniqueId}`); // collect all file keys for 'select all files'
        //         this.prevParentObj.children.push({
        //             key: `${type},${file.UniqueId}`,
        //             data: {
        //                 type: type,
        //                 name: file.Name,
        //                 created: new Date(file.TimeCreated).toLocaleString(),
        //                 updated: new Date(file.TimeLastModified).toLocaleString()
        //             }
        //         });
        //     }
        //
        //     // replace this.input with the updated this.prevParentObj
        //     this.input.forEach((el: any, index: any) => {
        //         if (el.key == this.prevParentObj.UniqueId) {
        //             el[index] = this.prevParentObj;
        //         }
        //     });
        // };

        // recursive function
        // const getSubfolders = async (folder: any) => {
        //     const getSubfoldersQueue = new PQueue({concurrency: 1});
        //
        //     const folderObj = await folder();
        //
        //     const subfolders = await folder.folders();
        //     subfolders.sort((a: any, b: any) => (a.Name.toLowerCase() > b.Name.toLowerCase()) ? 1 : ((b.Name.toLowerCase() > a.Name.toLowerCase()) ? -1 : 0));
        //     //   const subfolders = await queue.add(() => folder.folders());
        //
        //     if (subfolders.length == 0) {
        //         const files = await folder.files();
        //
        //         findParentFolder(folderObj);
        //         await loopFilesToUpdateInputData(files);
        //
        //         this.prevParentObj = null;
        //
        //         return;
        //     } else {
        //         for (const subfolder of subfolders) {
        //             if (subfolder.Name === 'Backup' || subfolder.Name === 'Output') continue; // ignore 'Backup' & 'Output' folders
        //
        //             const type = await getInputType(subfolder);
        //             this.filesKey.push(`${subfolder.UniqueId}`); // collect all file keys for 'select all files'
        //
        //             const subfolderArg = await this.updatedWebObj.getFolderByServerRelativeUrl(
        //                 subfolder.ServerRelativeUrl
        //             );
        //
        //             const parentFolder = await subfolderArg.parentFolder();
        //             /*
        //             to show the folder structure, the input array has its subfolders first, followed by its own files.
        //             since we are inside subfolder context, we need to obtain the files from the PARENT folder,
        //             then push into the children property
        //             */
        //             const files = await subfolderArg.parentFolder.files(); // get files in parent folder
        //
        //             const inputFolderObj: any = {
        //                 key: subfolder.UniqueId,
        //                 data: {
        //                     type: type,
        //                     name: subfolder.Name,
        //                     created: new Date(subfolder.TimeCreated).toLocaleString(),
        //                     updated: new Date(subfolder.TimeLastModified).toLocaleString()
        //                 },
        //                 children: []
        //             };
        //
        //             if (parentFolder.UniqueId == channelObj.UniqueId) {
        //                 // inside 1st subfolder layer, so parent folder is the channel folder
        //                 this.input.push(inputFolderObj);
        //             } else {
        //                 /*
        //                   inside 2nd or more nested folder.
        //                   this.prevParentObj stores the previous parent folder obj
        //                 */
        //
        //                 findParentFolder(parentFolder);
        //
        //                 // append the subfolder to the children of this.prevParentObj
        //                 this.prevParentObj.children.push(inputFolderObj);
        //                 await loopFilesToUpdateInputData(files);
        //             }
        //
        //             /*
        //               keep the initial value of this.prevParentObj,
        //               as it will be set to other values in the recursive function,
        //               but we need to keep its value for other subfolders (same level) in the for-of loop
        //             */
        //             const savePrevParentObj = this.prevParentObj;
        //
        //             // run the function recursively
        //             await getSubfoldersQueue.add(() => getSubfolders(subfolderArg));
        //
        //             this.prevParentObj = savePrevParentObj;
        //         }
        //     }
        // };

        // try catch blocks
        try {
            if (mode === 'lazy') {
                await loadFirstLayerFolders();
            }
            // else if (mode === 'eager') {
            //     await mainQueue.add(() => getSubfolders(channel));
            // }
        } catch (e) {
            this.startGetFile = false;
            this.error = true;
            this.errorMsg = `Errors occurred. Please ensure all the files were placed inside a folder.`;
        }
        // IGNORING FILES NOT INSIDE FOLDERS
        // const files = await channel.files(); // get files in folder
        // for (const file of files) {
        //   const type = await getInputType(file);
        //
        //   this.filesKey.push(`${type},${file.UniqueId}`); // collect all file keys for 'select all files'
        //   await mainQueue.add(() => {
        //     this.input.push({
        //       key: `${type},${file.UniqueId}`,
        //       data: {
        //         type: type,
        //         name: file.Name,
        //         created: new Date(file.TimeCreated).toLocaleString(),
        //         updated: new Date(file.TimeLastModified).toLocaleString()
        //       }
        //     });
        //   });
        // }

        this.dataLoaded = true;
    }

    async selectAll() {
        this.loadSelect = true;
        this.folderCount = 0;
        this.selectProgress = 0;
        for (const node of this.input) {
            await this.onExpandOrSelect(node, 'selectAll');
            this.folderCount++;
            this.selectProgress = Math.floor(this.folderCount * 100 / this.input.length);
        }
        this.selectedKey = {};

        this.filesKey.forEach((el: any) => {
            this.selectedKey[el] = {checked: true}
        });
        this.loadSelect = false;
    }

    cancelAll() {
        this.selectedKey = {};
    }

    async selectFiles() {
        this.success = false;
        this.error = false;
        this.filesCount = 0;
        this.mergeProgress = 0;

        if (Object.keys(this.selectedKey).length) {
            this.blockButton = true;
            this.selectedFiles = [];
            this.selectedFile = null;
            const keyArr = Object.keys(this.selectedKey);
            for (const el of keyArr) {
                if (el.split(',')[0] === 'File') {
                    const file = await this.updatedWebObj.getFileById(el.split(',')[1])();
                    this.selectedFiles.push(file);
                }
                this.filesCount++;
                this.mergeProgress = Math.floor(this.filesCount * 100 / keyArr.length);
            }
            this.blockButton = false;
        } else {
            this.selectedFiles = [];
        }
    }

    async onDialogShow(selectedFile: any) {
        this.loadPdf = true;
        const buffer = await this.updatedWebObj.getFileByServerRelativeUrl(selectedFile[0].ServerRelativeUrl).getBuffer();
        const blob = new Blob([buffer], {type: 'application/pdf'})
        this.pdfSrc = URL.createObjectURL(blob)
        this.loadPdf = false;
    }


    async combineFiles() {
        this.success = false;
        this.error = false;
        this.convertRecords = [];
        this.convertTime = 0;
        this.totalTime = 0;
        this.filesCount = 0;
        this.mergeProgress = 0;

        const excelArr = ['csv', 'xls', 'xlsb', 'xlsx', 'xlt', 'xltx'];
        const wordArr = ['docx', 'doc', 'dot', 'dotx', 'wps', 'wpd', 'rtf', 'wri', 'log'];
        const supportedFormat = excelArr.concat(wordArr).concat(['pdf', 'png', 'jpg']);

        function _arrayBufferToBase64(buffer: any) {
            let binary = '';
            const bytes = new Uint8Array(buffer);
            const len = bytes.byteLength;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        }

        const mergedPdf = await PDFDocument.create();
        mergedPdf.setTitle('Output')
        let convertToPdf = null;
        const jobId = uuidv4();
        const filesArr = [];

        for (const file of this.selectedFiles) {
            const fileExt = file.Name.substr(file.Name.lastIndexOf('.') + 1);
            const buffer = await this.updatedWebObj.getFileByServerRelativeUrl(file.ServerRelativeUrl).getBuffer();
            const base64String = _arrayBufferToBase64(buffer);

            if (!supportedFormat.includes(fileExt)) {
                this.error = true;
                this.errorMsg = `Files in ${fileExt} were not supported. Please try again with pdf, word or excel formats.`;
                return;
            }

            filesArr.push({
                jobId: jobId,
                name: file.Name,
                extension: fileExt,
                size: file.Length,
                directory: file.ServerRelativeUrl,
                order: this.filesCount + 1
            })

            // images: 'png' or 'jpg'
            if (fileExt === 'png' || fileExt === 'jpg') {
                try {
                    const image = fileExt === 'png' ? await mergedPdf.embedPng(buffer) : await mergedPdf.embedJpg(buffer);
                    const dims = image.scale(0.5);
                    const page = mergedPdf.addPage();
                    page.drawImage(image, {
                        x: page.getWidth() / 2 - dims.width / 2,
                        y: page.getHeight() / 2 - dims.height / 2,
                        width: dims.width,
                        height: dims.height,
                    });
                    continue;
                } catch (e) {
                    this.error = true;
                    this.errorMsg = `Cannot convert ${file.Name} to pdf. Please try again later.`;
                    return;
                }
            }

            // office-convert server
            if (wordArr.includes(fileExt) || excelArr.includes(fileExt)) {
                try {
                    convertToPdf = await axios.post(
                        'https://ocp.dita1.fhk-app.com/convert',
                        `{ "data": "${base64String}" }`,
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        }
                    );
                    this.convertRecords.push({
                        file: file.Name,
                        time: Math.round(convertToPdf.data.time / 1000)
                    });
                    this.convertTime += Math.round(convertToPdf.data.time / 1000)
                } catch (e) {
                    this.error = true;
                    this.errorMsg = `Cannot convert ${file.Name} to pdf. Please try again later.`;
                    return;
                }
            }

            try {
                const pdf = await PDFDocument.load(convertToPdf ? /*(convertToPdf.data.Files[0]).FileData*/ convertToPdf.data.result : buffer);
                const copyPage = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
                copyPage.forEach(el => mergedPdf.addPage(el));
            } catch (e) {
                this.error = true;
                this.errorMsg = `Cannot combine files into pdf. Please try again later.`;
                return;
            }
            convertToPdf = null;
            this.filesCount++;
            this.mergeProgress = Math.floor(this.filesCount * 100 / this.selectedFiles.length);
        }

        // add page number on each pages
        // const pages = await mergedPdf.getPages();
        // const helveticaFont = await mergedPdf.embedFont(StandardFonts.Helvetica);
        // for (const [i, page] of Object.entries(pages)) {
        //     page.drawText(`${+i + 1}`, {
        //         x: page.getWidth() / 2,
        //         y: 10,
        //         size: 15,
        //         font: helveticaFont,
        //         color: rgb(0, 0, 0)
        //     });
        // }

        this.combinedPdf = await mergedPdf.save();
        const blob = new Blob([this.combinedPdf], {type: 'application/pdf'})

        this.$store.commit('updateOutputBlob', blob)

        // add file details to DB
        try {
            await axios.post(
                'https://ocp.dita1.fhk-app.com/files',
                `{ "data": ${JSON.stringify(filesArr)} }`,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
        } catch (e) {
            this.error = true;
            this.errorMsg = `Cannot add files to database. Please try again later.`;
            return;
        }
    }

    // async uploadFiles() {
    //     const start = Date.now();
    //     this.blockButton = true;
    //
    //     await this.combineFiles();
    //
    //     if (this.combinedPdf) {
    //         try {
    //             await this.updatedWebObj.getFolderByServerRelativeUrl(`${this.serverRelativeUrl}/Output`).get();
    //         } catch (e) {
    //             await this.updatedWebObj.getFolderByServerRelativeUrl(this.serverRelativeUrl).folders.add('Output');
    //         }
    //
    //         await this.updatedWebObj.getFolderByServerRelativeUrl(
    //             `${this.serverRelativeUrl}/Output`
    //         ).files.add('output.pdf', this.combinedPdf, true);
    //
    //         // setTimeout(() => {
    //         //     window.location.reload();
    //         // }, 2000);
    //
    //         this.totalTime = Math.round((Date.now() - start) / 1000);
    //         this.success = true;
    //         this.successMsg = `Upload successfully. Total time used: ${this.totalTime} seconds. Result is available in the Output Tab`;
    //     }
    //
    //     this.blockButton = false;
    // }

    async downloadFiles() {
        const start = Date.now();
        this.blockButton = true;

        await this.combineFiles();

        if (this.combinedPdf) {
            const now = new Date()
            const date = [now.getFullYear(), now.getMonth() + 1, now.getDate()].map(d => d.toString().length === 1 ? "0" + d : d);
            const time = [now.getHours(), now.getMinutes(), now.getSeconds()].map(d => d.toString().length === 1 ? "0" + d : d);
            const teamName = this.selectedTeam.displayName.includes('Agreement No.') ? (this.selectedTeam.displayName.split('Agreement No.')[1]).trim() : this.selectedTeam.displayName;
            const fileName = `${this.selectedChannel.displayName}-${teamName}-${date.join("_")}-${time.join("_")}`
            download(this.combinedPdf, `${fileName}.pdf`, "application/pdf");

            // setTimeout(() => {
            //     window.location.reload();
            // }, 2000);

            this.totalTime = Math.round((Date.now() - start) / 1000);
            this.success = true;
            this.successMsg = `Download successfully. Total time used: ${this.totalTime} seconds. Result is available in the Output Tab`;
        }

        this.blockButton = false;
    }

    openModal(selectedFile: any) {
        if (selectedFile) {
            const fileExt = selectedFile[0].Name.substr(selectedFile[0].Name.lastIndexOf('.') + 1);
            fileExt === 'pdf' ? this.displayModal = true : window.open(selectedFile[0].LinkingUri, '_blank');
        }
    }
}
